var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPrimary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37256 18.6274 0 12 0C5.37258 0 0 5.37256 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5229 22 22 17.5229 22 12C22 6.47705 17.5229 2 12 2C6.47715 2 2 6.47705 2 12C2 17.5229 6.47715 22 12 22Z",
    fill: "#2D6CE6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 11C11 10.4477 11.4477 10 12 10C12.5523 10 13 10.4477 13 11V17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17V11Z",
    fill: "#2D6CE6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7C11 6.44772 11.4477 6 12 6C12.5523 6 13 6.44772 13 7C13 7.55228 12.5523 8 12 8C11.4477 8 11 7.55228 11 7Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPrimary);
export default __webpack_public_path__ + "static/media/info-primary.9acbfd507b8ab59be597b4a3f058471a.svg";
export { ForwardRef as ReactComponent };